export class PopupNotAllowedError extends Error 
{
  constructor(message?: string) {
    super(message); // Pass the message to the base class constructor
    this.name = 'PopupNotAllowedError'; // Set the name of the error

    // Set the prototype explicitly to preserve the instanceof checks
    Object.setPrototypeOf(this, PopupNotAllowedError.prototype);
  }
}